import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";
import { GoldCheck } from "@/components/GoldCheck";
import { Reveal, SectionHead } from "./Bits";

const since = (d) => d ? new Date(d).toLocaleDateString("de-DE", { month: "2-digit", year: "numeric" }) : "";

function Tile({ u, i }) {
  return (
    <Reveal as="li" delay={(i % 8) * 50}>
      <Link to={`/u/${u.user_id}`} data-testid={`cs-wall-${u.user_id}`}
        className="h-full flex items-center gap-3 rounded-2xl bg-white/90 border border-pink-100 p-3 hover:-translate-y-0.5 hover:border-pink-200 hover:shadow-[0_14px_30px_-20px_rgba(225,29,99,.5)] transition-[transform,box-shadow,border-color] duration-300">
        <span className="relative shrink-0">
          <UserAvatar userId={u.user_id} name={u.name} picture={u.picture} size="w-11 h-11" crown={false} />
          <span className="absolute -bottom-1 -right-1"><GoldCheck className="w-4 h-4" /></span>
        </span>
        <span className="min-w-0">
          <span className="block font-bold text-slate-900 truncate">{u.name}</span>
          {u.supporter_since && <span className="block text-[11px] text-slate-500">Unterstützer seit {since(u.supporter_since)}</span>}
        </span>
      </Link>
    </Reveal>
  );
}

export function SupporterWall() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/supporters/wall").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  return (
    <section data-testid="cs-wall" aria-labelledby="cs-wall-title">
      <SectionHead id="cs-wall-title" eyebrow="Unterstützer-Wand" title="❤️ Menschen, die an unsere Idee glauben"
        sub="Unsere Projekt Unterstützer – ohne Beträge und ohne Rangliste. Jede:r ist gleich wertvoll." />
      {list && list.length > 0 && <p className="mt-3 text-sm font-bold text-rose-600" data-testid="cs-wall-count">{list.length} {list.length === 1 ? "Herz" : "Herzen"} tragen unsere Community ❤️</p>}
      {!list ? <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>
        : list.length === 0 ? (
          <Reveal className="mt-6 rounded-3xl border-2 border-dashed border-pink-200 bg-white/70 p-8 text-center" data-testid="cs-wall-empty">
            <Heart className="w-8 h-8 mx-auto text-rose-300" />
            <p className="mt-2 text-sm text-slate-600">Noch steht hier niemand – werde der erste Projekt Unterstützer auf dieser Wand!</p>
          </Reveal>
        ) : <ul className="mt-6 grid grid-cols-1 min-[420px]:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="cs-wall-list">{list.map((u, i) => <Tile key={u.user_id} u={u} i={i} />)}</ul>}
    </section>
  );
}
